import React from "react";
import { Container } from "react-bootstrap";
var GridContainer = function (props) {
    return (React.createElement(Container, { className: props.parentClass, fluid: props.fluid, style: props === null || props === void 0 ? void 0 : props.style }, props.children));
};
export default GridContainer;
